import { Component, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'app-validation-tooltip',
  templateUrl: './validation-tooltip.component.html',
  styleUrls: ['./validation-tooltip.component.scss']
})
export class ValidationTooltipComponent implements AfterViewInit {
  @ViewChild('anchor', {static: false}) anchor: ElementRef;
  @ViewChild(TooltipDirective, {static: false}) tooltip: TooltipDirective;
  ngAfterViewInit() {
    if (this.tooltip) {
      this.tooltip.show(this.anchor);
    }
  }

}
